import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return {
    headers: {
      'Authorization': `Bearer ${user?.token}`,
      'Content-Type': 'application/json',
    },
  };
};

const login = async (credentials) => {
  const response = await axios.post(`${API_URL}/login`, credentials);
  return response.data;
};

const register = async (userData) => {
  const response = await axios.post(`${API_URL}/register`, userData);
  return response.data;
};

const logout = async () => {
  const response = await axios.post(`${API_URL}/logout`, {}, getAuthHeader());
  return response.data;
};

const checkAccountStatus = async () => {
  try {
    const response = await axios.get(`${API_URL}/account-status`, getAuthHeader());
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      // Account is not active
      return { success: false, active: false, message: 'Account is not active. Please contact administrator.' };
    }
    return { success: false, error: error.response?.data?.message || 'Failed to check account status' };
  }
};

export { login, register, logout, getAuthHeader, checkAccountStatus };
